import { ToastOptions } from "react-toastify";

const toastOptions: ToastOptions = {
  pauseOnFocusLoss: false,
  autoClose: 5000
}; 

export default toastOptions;